import React from 'react';
import {isFinalGradingPeriod, finalGradingPeriodMap} from 'shared/portfolio/utils';

interface Props {
  grade: {
    period: string;
    gradeInput?: string | null;
  };
  hover?: boolean;
}

const Grade = ({grade, hover}: Props) => {
  const getPeriodClassName = (gradeHover?: boolean, gradeEmpty?: boolean, finalHover?: boolean) => {
    let className = 'course-grade-period';

    if (gradeHover) {
      className += ' grade-hover';
    }
    if (gradeEmpty) {
      className += ' grade-empty';
    }
    if (finalHover) {
      className += ' final-hover';
    }

    return className;
  };

  const getCircleClassName = (
    gradeHover?: boolean,
    gradeEmpty?: boolean,
    finalFull?: boolean,
    finalHover?: boolean
  ) => {
    let className = 'course-grade-circle';

    if (gradeHover) {
      className += ' grade-hover';
    }
    if (gradeEmpty) {
      className += ' grade-empty';
    }
    if (finalFull) {
      className += ' final-full';
    }
    if (finalHover) {
      className += ' final-hover';
    }

    return className;
  };

  const gradeEmpty = !grade.gradeInput;
  const final = isFinalGradingPeriod(grade.period);
  const finalFull = !hover && isFinalGradingPeriod(grade.period) && !!grade.gradeInput;
  const finalHover = hover && isFinalGradingPeriod(grade.period) && !!grade.gradeInput;

  return (
    <div className={`course-grade ${final ? 'final' : ''}`}>
      <div className={getCircleClassName(hover, gradeEmpty, finalFull, finalHover)}>
        {grade.gradeInput || ''}
      </div>
      <div className={getPeriodClassName(hover, gradeEmpty, finalHover)}>
        {isFinalGradingPeriod(grade.period) ? finalGradingPeriodMap[grade.period] : grade.period}
      </div>
    </div>
  );
};

export default Grade;
